import React, { FC, ReactNode } from 'react';

import { SectionBody, SectionTitle, SectionWrapper } from './Controls.styled';

interface PanelSectionProps {
  title: string;
  children: ReactNode;
  action?: ReactNode;
}

export const PanelSection: FC<PanelSectionProps> = ({ title, children, action }) => (
  <SectionWrapper>
    <div className="flex items-center justify-between">
      <SectionTitle>{title}</SectionTitle>
      {action}
    </div>
    <SectionBody>{children}</SectionBody>
  </SectionWrapper>
);
